// Editable name shown under the Voice Bars (on the video and the thumbnail).
export function BarsLabelInput({ value, onChange, testId = "bars-label-input" }) {
  return (
    <label className="flex flex-col gap-1.5">
      <span className="text-[11px] font-semibold uppercase tracking-[0.18em] text-zinc-500">Name under the Voice Bars</span>
      <input value={value} onChange={(e) => onChange(e.target.value)} maxLength={30} data-testid={testId} placeholder="Reaction"
        className="w-full bg-white border border-zinc-200 hover:border-zinc-300 rounded-[4px] px-3 py-2.5 text-sm text-zinc-900 outline-none focus:border-rose-500 transition-colors" />
    </label>
  );
}
